import React from "react";
import { motion } from "framer-motion";
import { BookOpenIcon, DownloadIcon, GiftIcon, SmartphoneIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { bonuses, mainProduct, TOTAL_VALUE } from "../../data/offer";
import { mockupUrl } from "../../data/images";
import { EASE_OUT } from "../../utils/motion";
export function OfferStack() {
  return <section id="oferta" className="scroll-mt-24 bg-blush py-20 lg:py-28" data-id="element-249" data-mp="ot3b59fit9t8">
      <div className="mx-auto max-w-6xl px-5" data-id="element-250" data-mp="otv56ftgyzhe">
        <Reveal className="text-center" data-id="element-251" data-mp="tsps9tygza7b">
          <h2 className="font-display text-3xl font-bold text-cocoa sm:text-5xl" data-id="element-252" data-mp="trem5nhjxqd1">Esto Es Lo Que Recibes</h2>
          <p className="mx-auto mt-4 flex w-fit flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-semibold text-cocoa-light" data-id="element-253" data-mp="f17d1ydfpjp0">
            <span className="flex items-center gap-1.5" data-id="element-254" data-mp="17rfl2xe9anpv"><DownloadIcon className="h-4 w-4 text-berry" data-id="element-255" data-mp="17qe7om9rpp4z" /> Producto digital de descarga directa</span>
            <span className="flex items-center gap-1.5" data-id="element-256" data-mp="1cjyz1vguvkv7"><SmartphoneIcon className="h-4 w-4 text-berry" data-id="element-257" data-mp="18wmsu3blakmj" /> Celular, tablet o computadora</span>
          </p>
        </Reveal>

        <div className="mt-12 grid items-start gap-10 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-258" data-mp="13yuqsgh8di4m">
          <div className="lg:sticky lg:top-28" data-id="element-259" data-mp="1imxz3wiqx5wl">
            <Reveal x={-24} y={0} className="relative" data-id="element-260" data-mp="1iosktd1ud21q">
              <motion.img src={mockupUrl} alt="Pack Dulce Saludable: todos los recetarios y bonos" className="w-full rounded-[2rem] border-[10px] border-white shadow-[0_40px_80px_-30px_rgba(59,34,25,0.55)]" animate={{
              rotate: [-1, 1, -1]
            }} transition={{
              duration: 7,
              repeat: Infinity,
              ease: "easeInOut"
            }} data-id="element-261" data-mp="1dvprn60z7um2" />
              <motion.div initial={{
              opacity: 0,
              scale: 0.96
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: 0.2,
              ease: EASE_OUT
            }} className="absolute -right-2 -top-4 flex h-24 w-24 rotate-12 flex-col items-center justify-center rounded-full bg-berry text-center text-white shadow-xl sm:-right-5" data-id="element-262" data-mp="1wnihwsonv1q3">
                <span className="font-display text-2xl font-bold leading-none" data-id="element-263" data-mp="w003xsm33r01">100+</span>
                <span className="text-[11px] font-semibold uppercase" data-id="element-264" data-mp="10zcrkfks523o">recetas</span>
              </motion.div>
            </Reveal>
          </div>

          <div className="space-y-4" data-id="element-265" data-mp="1aw92ery5i0be">
            <Reveal data-id="element-266" data-mp="1av7e3ls4jhbq">
              <article className="overflow-hidden rounded-3xl bg-white shadow-[0_24px_60px_-30px_rgba(59,34,25,0.5)]" data-id="element-267" data-mp="1atmswmrp9aqj">
                <header className="flex items-start justify-between gap-4 bg-cocoa p-6 text-cream" data-id="element-268" data-mp="1jo1a4uvsivca">
                  <div className="flex gap-3" data-id="element-269" data-mp="1omksymf37r0f">
                    <BookOpenIcon className="mt-1 h-6 w-6 shrink-0 text-gold-light" data-id="element-270" data-mp="1omcewr78afnn" />
                    <div data-id="element-271" data-mp="1tn8it4rky1t2">
                      <h3 className="font-display text-xl font-bold sm:text-2xl" data-id="element-272" data-mp="1tjuie22h82o9">{mainProduct.title}</h3>
                      <p className="text-sm text-cream/75" data-id="element-273" data-mp="1yixkbdn5tss0">{mainProduct.subtitle}</p>
                    </div>
                  </div>
                  <span className="whitespace-nowrap font-bold text-cream/60 line-through" data-id="element-274" data-mp="3e3ggmqmvamwd">${mainProduct.value}</span>
                </header>
                <ul className="divide-y divide-blush" data-id="element-275" data-mp="395eutxy249h7">
                  {mainProduct.recipes.map(r => <li key={r.name} className="flex items-center gap-4 p-4" data-id="element-276" data-mp="347mssb3p76za">
                      <img src={r.image} alt="" className="h-14 w-14 shrink-0 rounded-xl object-cover" loading="lazy" data-id="element-277" data-mp="5mv4j0yxvdp1" />
                      <div data-id="element-278" data-mp="pv4p7son76d">
                        <p className="font-semibold text-cocoa" data-id="element-279" data-mp="3s3r4dksvrldb">{r.name}</p>
                        <p className="text-sm text-cocoa-light" data-id="element-280" data-mp="3s1o5eb9r2hwg">{r.detail}</p>
                      </div>
                    </li>)}
                </ul>
              </article>
            </Reveal>

            {bonuses.map((b, i) => <Reveal key={b.number} delay={i * 0.05} data-id="element-281" data-mp="jnpg1sha9urx" data-mpi={i}>
                <article className="flex items-center gap-4 rounded-3xl bg-white p-4 shadow-[0_16px_40px_-28px_rgba(59,34,25,0.5)]" data-id="element-282" data-mp="jm4g1nc79jmo">
                  <div className="relative shrink-0" data-id="element-283" data-mp="95aqgu17ajfe">
                    <img src={b.image} alt="" className="h-16 w-16 rounded-2xl object-cover" loading="lazy" data-id="element-284" data-mp="92xzjrdgsyq7" />
                    <span className="absolute -left-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-gold text-white shadow" data-id="element-285" data-mp="3qfikp70eyxdg">
                      <GiftIcon className="h-3.5 w-3.5" data-id="element-286" data-mp="mxgtdefcetww" />
                    </span>
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-287" data-mp="ru7920n8jnhs">
                    <p className="text-xs font-bold uppercase tracking-wide text-gold-dark" data-id="element-288" data-mp="d6m8addu20d1">Bono #{b.number}</p>
                    <p className="font-semibold leading-snug text-cocoa" data-id="element-289" data-mp="i5fmy94uvxes">{b.title}</p>
                    <p className="text-sm text-cocoa-light" data-id="element-290" data-mp="15v9xgk1pd9vv">{b.tagline}</p>
                  </div>
                  <div className="text-right" data-id="element-291" data-mp="1am01ntye76oz">
                    <p className="font-bold text-cocoa-light/70 line-through" data-id="element-292" data-mp="1amrzlbfgpgif">${b.value}</p>
                    <p className="text-xs font-bold uppercase text-leaf" data-id="element-293" data-mp="2vbdmf4kl9rxb">Gratis</p>
                  </div>
                </article>
              </Reveal>)}

            <Reveal data-id="element-294" data-mp="351ytzhi8q6sd">
              <div className="flex items-center justify-between rounded-3xl border-2 border-dashed border-cocoa/30 px-6 py-5" data-id="element-295" data-mp="352i080yj36qk">
                <p className="font-bold uppercase tracking-wide text-cocoa" data-id="element-296" data-mp="303nht04h3k6z">Valor total de la oferta</p>
                <p className="font-display text-3xl font-bold text-cocoa line-through decoration-berry decoration-[3px]" data-id="element-297" data-mp="2cdt7ap7mm7pw">${TOTAL_VALUE}</p>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal className="mt-14 text-center" data-id="element-298" data-mp="2lfk8phv4vsdy">
          <p className="font-display text-3xl font-bold text-cocoa sm:text-4xl" data-id="element-299" data-mp="2hc4gqyu0eg7l">
            PERO ESPERA: <span className="text-berry" data-id="element-300" data-mp="nh3vaelxkkk">Hoy NO pagarás eso.</span>
          </p>
          <p className="mt-2 font-script text-4xl text-cocoa-light" data-id="element-301" data-mp="3srt2xnzfvb7c">Ni siquiera cerca.</p>
        </Reveal>
      </div>
    </section>;
}